<mat-slide-toggle [(ngModel)]="value" [disabled]="disabled" (change)="changeValue($event)" color="primary">
	<mat-label class="pb-0">{{ label }}</mat-label>
</mat-slide-toggle>
